import { useState, useEffect, useCallback } from 'react';
import { useApi } from './useApi';

export const useSettings = () => {
  const [settings, setSettings] = useState(null);
  const { loading, error, get } = useApi();

  const fetchSettings = useCallback(async () => {
    const result = await get('/public/config');
    
    if (result.success) {
      setSettings(result.data);
    }
    
    return result;
  }, [get]);

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  return {
    settings,
    loading,
    error,
    fetchSettings,
  };
};

export default useSettings;
